import { defineStore } from 'pinia'

import type { Resource } from '../types'
import { useReactiveList } from './utils'

export const useResourceStore = defineStore('resource', () => {
  const { list: resources, populate } = useReactiveList<Resource>()

  return { resources, populate }
})
